const ja = {
  questionPaperLibrary: "問題用紙ライブラリ",
  questionPaperLibraryDescription:
    "個別の問題を作成し、包括的な問題用紙を設計するためのダイナミックなワークスペース。",
  assessmentLibrary: "評価ライブラリ",
  assessmentLibraryDescription:
    "スケジュールを管理し、参加者を招待し、パフォーマンスレポートを一元的なハブで追跡します。",
  myAssessmentWidgetTitle: "マイアセスメント",
  myPreferences: "マイ設定",
  assessmentsForYou: "あなた向けのアセスメント",
  exploreAssessmentsAssignedToYou:
    "あなたに割り当てられたアセスメントを確認しましょう",
  hitachiAcademy: "日立アカデミー",
  essentialBusinessKnowledgeTestForYou: "あなたのための必須ビジネス知識テスト",
  continuousLearningJourneyDescription:
    "継続的な学習の中で、ビジネススキルの理解と強化を支援するために設計されています",
  noActiveAssessmentsScheduledForYou:
    "あなた向けの有効なアセスメント予定はありません",
  upcoming: "今後",
  notAttempted: "未受験",
  myAssessmentCardDescription:
    "このアセスメントは、GlobalLogicのキャンパス採用プロセスの一環として、技術力、分析力、問題解決力を評価します。",
  totalDuration: "合計時間",
  startTime: "開始時刻",
  questionAuthoring: "問題作成",
  reviewQuestions: "問題を確認",
  bulkUploadHistory: "一括アップロード履歴",
  bulkActionHistory: "一括操作履歴",
  editQuestion: "問題を編集",
  inviteParticipants: "参加者を招待",
  externalUserBulkUploadHistory: "外部ユーザー一括アップロード履歴",
  assessmentSchedule: "評価スケジュール",
  assessmentReport: "評価レポート",
  bulkHistory: "一括履歴",
  myUpload: "マイアップロード",
  bulkUpload: "一括アップロード",
  createQuestion: "問題を作成",
  bulkUploadQuestions: "問題の一括アップロード",
  filters: "フィルター",
  clear: "クリア",
  searchByTitle: "タイトルで検索",
  refresh: "更新",
  refreshing: "更新中",
  reviewQuestionPapers: "問題用紙をレビュー",
  myQuestionPapers: "自分の問題用紙",
  viewQuestionBank: "問題バンクを表示",
  createNew: "新規作成",
  sortBy: "並び替え",
  state: "状態",
  reviewed: "レビュー済み",
  reviewedTooltip: "レビュー後に公開された問題用紙を表示します。",
  all: "すべて",
  draft: "下書き",
  published: "公開済み",
  inReview: "レビュー中",
  sentBack: "差し戻し",
  readyToPublish: "公開準備完了",
  draftDescription:
    "問題用紙の作成はまだ進行中で、受講者にはまだ利用できません",
  publishedDescription: "問題用紙は公開中で、受講者がアクセスできます",
  inReviewDescription: "問題用紙はレビュー中で、まだ承認されていません",
  sentBackDescription: "問題用紙は修正のため差し戻されました",
  readyToPublishDescription: "問題用紙は公開の準備ができています",
  createdAt: "作成日",
  updatedAt: "更新日",
  publishedAt: "公開日",
  descending: "降順",
  ascending: "昇順",
  success: "成功",
  error: "エラー",
  warning: "警告",
  info: "情報",
  yes: "はい",
  no: "いいえ",
  noMatchingContentFound: "一致するコンテンツが見つかりません",
  noQuestionPapersAvailableForReview: "レビュー可能な問題用紙がありません",
  questionPaperNotYetCreated: "問題用紙はまだ作成されていません",
  createQuestionPaperDescription:
    "受講者のスキルと知識を評価するための問題用紙を作成します",
  createYourFirstQuestionPaper: "最初の問題用紙を作成",
  createQuestionPaperModalTitle: "問題用紙を作成",
  questionsTab: "質問",
  questionPaperSettingsTab: "問題用紙の設定",
  editQuestionPaper: "質問用紙を編集する",
  save: "保存",
  publish: "公開",
  sendForReview: "レビューのために送信",
  sendingForReview: "レビューのために送信中",
  publishing: "出版",
  clone: "クローン",
  delete: "消去",
  view: "ビュー",
  edit: "編集",
  close: "近い",
  create: "作成する",
  creating: "作成",
  confirm: "確認する",
  cancel: "キャンセル",
  version: "バージョン",
  untitled: "無題",
  noVersion: "バージョンなし",
  title: "タイトル",
  status: "状態",
  action: "アクション",
  createdBy: "作成者",
  createNewVersion: "+ 新しいバージョン",
  createNewVersionTitle: "新しいバージョンの作成",
  deleteQuestionPaperPrompt: "この質問用紙を削除してもよろしいですか?",
  deleteQuestionPaperWithTitlePrompt:
    "「{{title}}」というタイトルのこの質問用紙を削除しますか?",
  cloneQuestionPaperPrompt: "この質問用紙のコピーを作成しますか?",
  publishQuestionPaperPrompt: "この質問用紙を公開してもよろしいですか?",
  sendForReviewQuestionPaperPrompt:
    "確認のためにこの質問用紙を送信してもよろしいですか?",
  successfullyDeletedQuestionPaper: "問題用紙が正常に削除されました",
  successfullyMovedQuestionPaperToDraft:
    "質問用紙をドラフトに正常に移動しました",
  successfullySavedQuestionPaperData: "問題用紙データの保存に成功しました",
  successfullyClonedQuestionPaper: "問題用紙の複製に成功しました",
  successfullyCreatedQuestionPaper: "問題用紙の作成に成功しました",
  validationFailedWithFollowingErrors: "検証は次のエラーで失敗しました:",
  failedStatusUpdateOf: "のステータス更新に失敗しました:",
  savedWithFollowingWarnings: "次の警告とともに保存されました:",
  reviewedAndPublished: "レビューされて公開されました",
  deleting: "削除中...",
  cloning: "クローン作成中...",
  assessment: "評価",
  public: "公共",
  private: "プライベート",
  visibility: "可視性",
  questionType: "質問の種類",
  selectQuestionTypeAndVisibility: "質問の種類と公開範囲を選択してください",
  singleChoice: "単一選択",
  multipleChoice: "多肢選択",
  trueOrFalse: "正誤",
  fillInTheBlanks: "空白を埋めてください",
  codingQuestion: "コーディングに関する質問",
  subjectiveQuestion: "主観的な質問",
  speakingQuestion: "スピーキング質問",
  downloadTemplateEditAndReuploadQuestions:
    "テンプレートをダウンロードし、質問リストを編集して再アップロードします",
  downloadExcelTemplateInstruction:
    "下のボタンからExcelテンプレートをダウンロードしてください。",
  addQuestionsToSheetInstruction:
    "質問をシートに追加します (手順はシート内に記載されています)。",
  uploadCompletedExcelInstruction:
    "質問を一括インポートするには、完成した Excel ファイルをアップロードします。",
  uploading: "アップロード中...",
  uploadQuestions: "質問をアップロードする",
  completed: "完了",
  invalid: "無効",
  initiated: "開始済み",
  failed: "失敗した",
  fileName: "ファイル名",
  templateType: "テンプレートの種類",
  uploadedAt: "アップロード先",
  actions: "アクション",
  mcqTemplate: "MCQ テンプレート",
  fibTemplate: "FIB テンプレート",
  monitorUploadExcelDescription:
    "アップロードされた各 Excel ファイルを監視し、追加または失敗した質問の数を確認し、必要に応じてエラーの詳細を表示します。",
  reset: "リセット",
  showing: "表示中",
  to: "に",
  of: "の",
  results: "結果",
  noExcelFound: "Excel が見つかりません",
  cloneAssessmentConfirmation: "クローン評価の確認",
  cloneAssessmentWithTitlePrompt:
    "「{{title}}」というタイトルのこの評価を複製してもよろしいですか?",
  successfullyClonedAssessment: "評価が正常に複製されました",
  newVersionContentPrompt:
    "このコンテンツの新しいバージョンを作成しようとしています。さらに変更を加えた場合は、このバージョンに保存されます。続けますか?",
  createVersionWithNumber: "作成 (V{{version}})",
  addYourComment: "コメントを追加してください",
  maxLimitReached: "上限に達しました",
  deleteContentPrompt: "この {{contentType}} を削除してもよろしいですか?",
  deleteContentWithTitlePrompt:
    "「{{title}}」というタイトルのこの {{contentType}} を削除してもよろしいですか?",
  schedulePreview: "スケジュールのプレビュー",
  reschedule: "スケジュールを変更する",
  cancelled: "キャンセル",
  copyLink: "リンクをコピー",
  assessmentIsCancelled: "評価がキャンセルされました",
  deleteConfirmation: "削除の確認",
  cancelConfirmation: "キャンセルの確認",
  deleteAssessmentPrompt: "この評価を削除してもよろしいですか?",
  cancelAssessmentPrompt: "この評価をキャンセルしてもよろしいですか?",
  rescheduleAssessment: "評価の再スケジュール",
  customTermsAndConditions: "カスタム利用規約",
  viewTermsAndConditions: "利用規約を見る",
  scheduleNewAssessment: "新しい評価のスケジュールを設定する",
  selectQuestionPaper: "質問用紙を選択",
  createAssessment: "評価を作成",
  failedToLoadData: "データのロードに失敗しました!",
  assessmentNotYetCreated: "評価はまだ作成されていません",
  createAssessmentDescription:
    "学習者のスキルと知識を評価するための評価を作成する",
  createYourFirstAssessment: "最初の評価を作成する",
  failedToLoadSchedules: "スケジュールのロードに失敗しました",
  errors: "エラー:",
  basicInformation: "基本情報",
  assessmentName: "評価名",
  na: "NA",
  scheduleInstructions: "スケジュールの指示",
  noInstructionsProvided: "説明書は提供されていません",
  accessCriteria: "アクセス基準",
  searchTags: "タグを検索",
  viewAttributes: "属性の表示",
  termsAndConditions: "利用規約",
  enabled: "有効",
  disabled: "無効",
  requireCandidatesToAcceptTerms:
    "評価を開始する前に候補者に利用規約への同意を要求する",
  proctoringSettings: "保護設定",
  enableVideoProctoring: "ビデオ保護を有効にする",
  maximumVideoViolationsAllowed: "許可されるビデオ違反の最大数",
  enableBrowserProctoring: "ブラウザ保護を有効にする",
  maximumBrowserViolationsAllowed: "許可されるブラウザ違反の最大数",
  displayViolationsToCandidates: "候補者に違反を表示する",
  actionWhenViolationLimitReached: "違反制限に達した場合のアクション",
  flagged: "フラグ付き",
  terminate: "終了",
  stakeholdersAndFeedback: "関係者とフィードバック",
  owner: "所有者",
  recruiter: "採用担当者",
  allowCandidateFeedback: "候補者のフィードバックを許可する",
  enableCandidateFeedbackDescription:
    "候補者が評価完了後にフィードバックを送信できるようにする",
  schedulingAndTimerSettings: "スケジュールとタイマーの設定",
  scheduleType: "スケジュールの種類",
  loginWindow: "ログインウィンドウ",
  durationBased: "期間ベース",
  deadline: "締め切り",
  autoCompleteMode: "オートコンプリートモード",
  startDateAndTime: "開始日時",
  loginWindowInMinutes: "ログインウィンドウ (分単位)",
  endDateAndTime: "終了日時",
  timerEnabled: "タイマー有効",
  assessmentRules: "評価ルール",
  assessmentPattern: "評価パターン",
  resultVisibility: "結果の可視性",
  passPercentage: "合格率",
  maximumAttemptsAllowed: "許可される最大試行回数",
  unlimitedAttempts: "無制限の試行",
  attempt: "試み",
  attempts: "試み",
  coolOffPeriodBetweenAttempts: "試行間の冷却期間",
  questionDisplaySettings: "質問表示設定",
  showQuestionTitle: "質問のタイトルを表示",
  showQuestionTitleDescription: "各質問の上に質問タイトルを表示します",
  showHint: "ヒントを表示",
  hintLoading: "別のヒントを見る前に待つ必要があります",
  allHintsShown: "保留中のヒントはありません",
  showHintDescription: "評価中に受験者を支援するヒントを有効にする",
  showExplanation: "説明を表示",
  hideExplanation: "説明を非表示",
  showExplanationDescription: "各質問の送信後に説明を表示する",
  showQuestionMarks: "疑問符を表示する",
  showQuestionMarksDescription: "各質問のマーク/スコア値を表示します",
  showWatermark: "透かしを表示",
  showWatermarkDescription:
    "各質問の候補者の電子メールを透かしとして表示します",
  questionPaperPreview: "問題用紙のプレビュー",
  questionPaperReview: "質問用紙のレビュー",
  createSchedule: "スケジュールの作成",
  reviewerComments: "査読者のコメント",
  reviewComments: "レビューコメント",
  sendBackQuestionPaperPrompt: "この質問用紙を返送してもよろしいですか?",
  moveQuestionPaperToDraftPrompt:
    "この質問用紙をドラフトに移してもよろしいですか?",
  markQuestionPaperReadyToPublishPrompt:
    "この質問用紙を公開準備完了としてマークしてもよろしいですか?",
  questionPaperStatusUpdatedSuccessfully:
    "問題用紙のステータスが正常に更新されました。",
  newVersionQuestionPaperCreatedSuccessfully:
    "問題用紙の新しいバージョンが正常に作成されました。",
  questionPaperClonedSuccessfully: "問題用紙の複製が成功しました。",
  startAddingQuestionsPreview: "ここで質問を追加してプレビューしてください",
  bulkInviteParticipants: "参加者を一括招待",
  bulkInviteParticipantsDescription:
    "事前に入力された Excel ファイルをアップロードすることで、複数の参加者を一度に招待します。正しい形式を確保するには、提供されているテンプレートを使用してください。",
  maxParticipantsPerFileNote:
    "ファイルあたり最大 200 人の参加者。重複または無効なエントリはエラーでスキップされます。",
  downloadTemplate: "テンプレートをダウンロード",
  creatingUser: "ユーザーを作成しています...",
  bulkInviteLabel: "一括招待",
  createAndInvite: "作成して招待する",
  myUploads: "私のアップロード",
  enterIndividualsForInvite:
    "評価に招待したい 1 人以上の個人の名前を入力します",
  searchPeopleByEmailOrName: "メールアドレスまたは名前で人を検索",
  noResultsFound: "結果が見つかりませんでした",
  loading: "読み込み中..",
  or: "または",
  multipleEmailsInviteDescription:
    "複数のユーザーを評価に招待するには、複数のユーザーの電子メールをカンマで区切って追加します。",
  addCandidates: "候補者の追加",
  pleaseEnterValidNameOrEmail:
    "有効な名前またはメールアドレスを入力してください",
  pleaseEnterValidEmailAddress: "有効なメールアドレスを入力してください",
  someEmailsCouldNotBeAdded: "一部のメールアドレスを追加できませんでした",
  checkInvalidEmailIds:
    "次の電子メール ID を確認してください - 無効であるようです:",
  failedToSendInvitesFollowingEmails: "次のメールに招待を送信できませんでした:",
  successfullyInvitedMembers: "{{count}} メンバーを招待しました",
  validationFailed: "検証に失敗しました",
  excelUploadedSuccessfully: "Excel が正常にアップロードされました",
  invalidBulkNominationTemplate: "無効な一括指名テンプレート",
  actionCompletedWithWarnings: "アクションは次の警告とともに完了しました:",
  actionFailedWithErrors:
    "アクションを完了できず、次のエラーが発生して終了しました:",
  trackBulkOperationsAndResults: "すべての一括操作とその結果を追跡する",
  partiallySaved: "部分的に保存されました",
  statusInitiatedDescription: "質問更新リクエストが送信され、処理中です。",
  statusCompletedDescription: "選択した質問はすべて正常に更新されました。",
  statusFailedDescription:
    "選択された質問はいずれも正常に処理できませんでした。",
  statusPartiallySavedDescription:
    "一部の質問は正常に保存されましたが、他の質問には問題が発生しました。",
  draftReadyToPublishToPublish: "下書き/公開準備完了 -> 公開",
  actionType: "アクションの種類",
  uploadedOn: "アップロード日",
  viewDetails: "詳細を見る",
  loadingRecords: "レコードをロード中...",
  noRecordsFound: "記録が見つかりませんでした",
  recordsPerPage: "ページごとのレコード:",
  page: "ページ",
  untitledQuestion: "無題の質問",
  globalLogic: "グローバルロジック",
  aiGenerated: "AI が生成",
  fullScreen: "全画面表示",
  exitFullScreen: "全画面表示を終了する",
  skills: "スキル",
  tags: "タグ",
  allowedCodingLanguages: "許可されるコーディング言語",
  marks: "マーク",
  lastUpdatedAt: "最終更新日",
  solutionCode: "ソリューションコード",
  solution: "解決",
  starterCode: "スターターコード",
  options: "オプション",
  explanation: "説明",
  hint: "ヒント",
  deleteQuestion: "質問を削除",
  noSections: "追加されたセクションはありません",
  editAndPublish: "編集と公開",
  sendBackToDraftInstruction:
    "返送ボタンをクリックして質問を下書きに戻します。",
  updateStatusReadyToPublishInstruction:
    "「公開準備完了」ボタンをクリックしてステータスを更新します。",
  successfullyUpdatedStatus: "ステータスが正常に更新されました",
  dismiss: "却下する",
  ongoing: "進行中",
  toBeLaunched: "公開予定",
  contentExpired: "コンテンツの有効期限切れ",
  notApplicable: "該当なし",
  expiresSoon: "まもなく期限切れ",
  contentCreationInProgressTooltip:
    "コンテンツ作成は進行中で、まだ学習者には利用できません",
  contentLiveAccessibleTooltip:
    "コンテンツは公開中で、学習者がアクセスできます",
  contentAvailableWithinDatesTooltip:
    "コンテンツは公開開始日と終了日の範囲内にあるため、現在利用可能です",
  contentNotLaunchedAvailableOnTooltip:
    "コンテンツはまだ公開されておらず、次の日付で利用可能になります",
  contentExpiredOnTooltip: "このコンテンツの有効期限は次の日付で終了しました",
  statusAvailableAfterPublishTooltip:
    "ステータスはコンテンツ公開後に利用可能になります",
  contentExpiresWithin48HoursTooltip:
    "このコンテンツは48時間以内に期限切れになります。",
  moveToDraftOrCloneToEdit:
    "編集するには下書きに戻すか、クローンを作成してください",
  webContent: "Webコンテンツ",
  eLearning: "Eラーニング",
  untitledContent: "無題のコンテンツ",
  sendToDraft: "下書きに戻す",
  sendToDraftPublishedInstruction:
    "このコンテンツはすでに公開されています。変更するには「下書きに戻す」ボタンをクリックしてください。",
  copyLinkForLearner: "学習者向けリンクをコピー",
  questionPaperName: "問題用紙名",
  type: "種別",
  duration: "所要時間",
  minutes: "分",
  difficultyLevel: "難易度",
  language: "言語",
  timezone: "タイムゾーン",
  preferredLocation: "希望する勤務地",
  notSelected: "未選択",
  selectedPreferencesHeading: "選択した設定",
  selectedPreferencesInfo: "快適な体験のために選択された設定",
  shortDescription: "概要",
  totalMarks: "合計点",
  questionPaperInstructions: "問題用紙の説明",
  expiryDate: "有効期限",
  knowledgeCategory: "知識カテゴリ",
  category: "カテゴリ",
  subCategory: "サブカテゴリ",
  region: "地域",
  usage: "用途",
  internalUseOnly: "社内利用のみ",
  externalUseOnly: "社外利用のみ",
  availableForAll: "全員に利用可能",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "ラテンアメリカ",
  northAmerica: "北米",
  globalRegion: "グローバル",
  automotive: "自動車",
  bankingFinancialServicesInsurance: "銀行・金融サービス・保険",
  connectivitySolutionsCommunication: "接続ソリューション/通信",
  consumerRetail: "消費財・小売",
  healthcareLifeSciences: "ヘルスケア・ライフサイエンス",
  manufacturingAndIndustrial: "製造業・産業",
  mediaEntertainment: "メディア・エンターテインメント",
  technology: "テクノロジー",
  other: "その他",
  behavioralInterpersonal: "行動面/対人関係",
  technical: "技術",
  processAndTools: "プロセスとツール",
  polishLanguage: "ポーランド語",
  spanishLanguage: "スペイン語",
  japaneseLanguage: "日本語",
  germanLanguage: "ドイツ語",
  ukrainianLanguage: "ウクライナ語",
  swedishLanguage: "スウェーデン語",
  romanianLanguage: "ルーマニア語",
  slovakLanguage: "スロバキア語",
  croatianLanguage: "クロアチア語",
  englishUsLanguage: "英語 (US)",
  englishUkLanguage: "英語 (UK)",
  englishInLanguage: "英語 (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "自動車標準とプロトコル",
  businessAnalysis: "ビジネス分析",
  cCpp: "C/C++",
  cloudDataScience: "クラウドデータサイエンス",
  bigData: "ビッグデータ",
  dataAnalytics: "データ分析",
  databaseTech: "データベース",
  developmentTools: "開発ツール",
  devops: "DevOps",
  embedded: "組み込み",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linuxカーネル",
  mobileDev: "モバイル開発",
  networking: "ネットワーキング",
  operatingSystemsServers: "オペレーティングシステムとサーバー",
  otherTech: "その他 - 技術",
  productivityTools: "生産性ツール",
  programmingLangOther: "プログラミング言語 - その他",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "ソフトウェア工学",
  uxUi: "UX/UI",
  architectureTech: "アーキテクチャ",
  golang: "Golang",
  requirementEngineeringTechnicalWriting: "要件工学/テクニカルライティング",
  onboarding: "オンボーディング",
  glTools: "GLツール",
  processAndPolicies: "プロセスとポリシー",
  communicationSubCategory: "コミュニケーション",
  personalEffectiveness: "個人の有効性",
  methodologies: "方法論",
  projectManagement: "プロジェクト管理",
  peopleManagement: "人材管理",
  leadershipPrograms: "リーダーシッププログラム",
  domain: "ドメイン",
  reviewer: "レビュアー",
  none: "なし",
  questionPaperPreviewBreadcrumb: "問題用紙プレビュー: {{title}}",
  questionPaperInReviewContactReviewer:
    "この問題用紙は現在レビュー中です。レビュアーに連絡してください。",
  randomization: "ランダム化",
  randomizationInSectionDescription:
    "このセクションの問題は受験者にランダムな順序で表示されます",
  questionPreviewPlaceholderImage: "問題プレビューのプレースホルダー",
  createNewVersionPromptWithNumber: "新しいバージョンを作成 (V{{version}})?",
  questionPreviewBreadcrumb: "問題プレビュー: {{title}}",
  questionPreviewTitle: "問題プレビュー",
  adminView: "管理者ビュー",
  candidateView: "受験者ビュー",
  viewAsCandidate: "受験者として表示",
  closePanel: "パネルを閉じる",
  internalQuestion: "内部向け問題",
  expiresOn: "有効期限",
  expiredLabel: "期限切れ",
  solutionNotAdded: "解答が追加されていません",
  testCases: "テストケース",
  testCasesNotAdded: "テストケースが追加されていません",
  starterCodeNotAdded: "スターターコードが追加されていません",
  groupTitleLengthValidation:
    "グループタイトルは5文字より多く、120文字未満で入力してください",
  addTitleHere: "ここにタイトルを追加...",
  groupUpdatedSuccessfully: "グループが正常に更新されました",
  groupDeletedSuccessfully: "グループが正常に削除されました",
  group: "グループ",
  numberOfQuestionsToBeShown: "表示する問題数",
  questionLimitPerSectionDescription:
    "各セクションで受験者に表示する問題数を制限します",
  numberOfQuestionsToShow: "表示する問題数 {{picked}}/{{total}}",
  collapseGroup: "グループを折りたたむ",
  expandGroup: "グループを展開する",
  groupSetupStartAddingQuestions:
    "このセクションにはグループが設定されています。問題の追加を開始してください。",
  addMoreQuestions: "問題をさらに追加",
  addQuestionFromLibrary: "ライブラリから問題を追加",
  questionDeletedSuccessfully: "問題が正常に削除されました",
  questionsShownCountUpdated: "表示する問題数が更新されました",
  failedToDeleteQuestion: "問題の削除に失敗しました",
  caseSensitive: "大文字と小文字を区別",
  caseSensitiveDescription:
    "有効にすると、学習者は大文字と小文字を完全に一致させて回答を入力する必要があります。",
  enterYourAnswerBelow: "以下に回答を入力してください",
  caseSensitiveAnswerInfo:
    "この問題は大文字と小文字を区別します。回答は正確な大文字と小文字で入力してください。",
  answerWithNumber: "回答 {{number}}",
  inviteEmailsPlaceholder: "user1@globallogic.com、user2@globallogic.com",
  visibleTestCases: "表示テストケース",
  hiddenTestCases: "非表示テストケース",
  visibleLabel: "表示",
  hiddenLabel: "非表示",
  responseSetting: "応答設定",
  recordingLimit: "録画時間上限",
  minimumResponseDuration: "最小応答時間",
  uploadLimit: "アップロード上限",
  practiceAllowed: "練習を許可",
  standardEvaluationRubricInfo:
    "これは、この質問に対する候補者の回答を評価するために使用される標準評価ルーブリックです。",
  criteria: "評価基準",
  weightPercentage: "重み(%)",
  viewRemarks: "備考を表示",
  input: "入力",
  expectedOutput: "期待される出力",
  actualOutput: "実際の出力",
  untitledSection: "無題のセクション",
  testSectionDescription: "テストセクションの説明",
  groupAddedSuccessfully: "グループが正常に追加されました",
  addGroupToSection: "セクションにグループを追加",
  deleteSection: "セクションを削除",
  questionPaperDetails: "問題用紙の詳細",
  skillsInfoMessage:
    "この問題用紙が評価することを目的とした重要なスキルをリストアップしてください。",
  contentSettings: "コンテンツ設定",
  stakeholderAndReview: "ステークホルダーとレビュー",
  statusType: "ステータスの種類",
  notReviewed: "未レビュー",
  sourceType: "ソースタイプ",
  proficiency: "熟練度",
  beginner: "初心者",
  intermediate: "中級",
  advanced: "高度な",
  wecp: "WECP",
  enterMarks: "マークを入力してください",
  removeSkill: "スキルを削除する",
  searchSkills: "検索スキル",
  noSkillsFound: "スキルが見つかりませんでした。",
  enterTag: "タグを入力してください",
  enterOwner: "所有者を入力",
  enterReviewer: "レビュアーを入力",
  noUserWithRole: "この役割を持つユーザーが見つかりません",
  createSection: "セクションを作成",
  untitledGroup: "タイトルなしのグループ",
  createGroup: "グループを作成",
  collapseSections: "セクションを折りたたむ",
  expandSections: "セクションを展開",
  assessmentNamePlaceholder: "評価名を入力してください",
  questionPaperTitleInfo: "質問用紙に明確でわかりやすいタイトルを入力します。",
  shortDescriptionPlaceholder: "簡単な説明を入力してください",
  shortDescriptionInfo: "問題用紙の内容を説明する簡単な概要。",
  questionPaperInstructionsInfo:
    "質問用紙を開始する前に受験者に表示される指示を書きます。セクションのルール、質問形式、ナビゲーションのヒント、提出ガイドラインなどの重要な詳細を含めます。",
  questionPaperInstructionsPlaceholder:
    "学習者が評価を開始する前に、期間、合格基準、許可されるツール、ガイドラインなどの重要な指示を追加します。",
  totalMarksAutoCalculatedInfo:
    "合計点は、各グループで選択された質問の数に基づいて自動的に計算されます。表示する問題数を 0 に設定した場合、そのグループは合計点から除外されます。",
  questionPaperType: "質問用紙の種類",
  questionPaperTypeInfo: "問題用紙の形式を選択します。",
  durationInfo: "問題用紙を完成させるための合計制限時間を設定します (分単位)。",
  difficultyLevelInfo:
    "候補者の経験に基づいて、予想される難易度レベルを選択します。",
  languageInfo: "問題用紙が表示される言語を選択します。",
  tagsInfo:
    "キーワードを追加すると、他の人が検索を通じてこの質問用紙を見つけやすくなります。",
  selectCategory: "カテゴリの選択",
  createLevel: "作成する",
  evaluate: "評価する",
  analyze: "分析する",
  apply: "適用する",
  understand: "理解する",
  remember: "覚えて",
  allowedCodingLanguagesRequiredInfo:
    "このフィールドは、問題用紙にコーディングの質問を追加する場合にのみ必須です。",
  knowledgeCategoryInfo:
    "この質問用紙が対象とする認知スキル レベル (例: 思い出す、理解する、適用する) を選択します。",
  allowedCodingLanguagesInfo:
    "この質問用紙の質問のコーディングに許可されているプログラミング言語を選択します。",
  expiryDateInfo:
    "この質問用紙を使用できなくなる日付をオプションで設定します。",
  visibilityInfo: "問題用紙の表示を選択します",
  visibilityLockedInfo:
    "問題用紙が公開公開されると、他のすべてのバージョンも公開公開されます。同様に、プライベートとして公開された場合、すべてのバージョンはプライベートのままになります。",
  reviewRequired: "要レビュー",
  reviewRequiredLockedInfo:
    "「レビューが必要」設定は、問題用紙のすべてのバージョンで同期されます。レビューを有効または無効にしてバージョンを公開すると、同じ設定がすべてのバージョンに適用され、個別に編集することはできません。",
  reviewRequiredInfo:
    "この質問用紙を公開する前に正式なレビュー プロセスを通過する必要がある場合に有効にします。",
  savingData: "データを保存中...",
  questionDataSavedSuccessfully: "質問データは正常に保存されました",
  sendQuestionForReviewInstruction:
    "[レビュー用に送信] ボタンをクリックしてレビュー担当者に送信し、レビューしてもらいます。",
  publishQuestionInstruction:
    "質問を公開するには、公開ボタンをクリックします。",
  noLearningContentAddedAfterSelectingYes:
    "「はい」を選択しても学習コンテンツは追加されません",
  expectedTimeInMinutes: "予想時間(分)",
  codingMarksAutoCalculatedInfo:
    "このマークは、この質問に追加された非表示のテスト ケースに基づいて自動的に計算されます。",
  skillsInfoMessageQuestion:
    "質問から参加者が習得できる具体的なスキルを提供する",
  skillsSubtitleQuestion: "この質問に関連付けられたスキルを設定します",
  allowedCodingLanguagesInfoQuestion:
    "この質問を解くために利用できる言語を選択してください",
  selectCodingLanguages: "コーディング言語の選択",
  allLanguages: "すべての言語",
  tagsInfoQuestion:
    "イベントを分類、説明、識別するためのキーワードを提供します",
  tagsSubtitleQuestion: "クイック検索用のタグを設定する",
  knowledgeCategorySubtitleQuestion:
    "認知スキルのレベルに応じて質問を分類するのに役立ちます。",
  explanationNotAvailableForSpeakingQuestion:
    "スピーキング質問には説明がありません",
  ownerVersionSyncInfo:
    "このバージョンの所有者を変更すると、作成されたすべてのバージョンでも更新されます。",
  ownerInfoMessage: "質問の主な所有者を選択してください",
  ownerReviewerCannotBeSame: "所有者とレビューアーが同じであることはできません",
  reviewerInfoMessage:
    "個人または個人のグループをレビュー担当者として選択します",
  stakeholdersUpdatedSuccessfully: "関係者が正常に更新されました。",
  unexpectedErrorCreatingNewVersion:
    "新しいバージョンの作成中に予期しないエラーが発生しました。",
  previewAndPublish: "プレビューと公開",
  viewAnalytics: "分析を見る",
  cloneQuestionPrompt: "この質問をコピーしますか?",
  evaluationRubric: "評価ルーブリック",
  problemStatement: "問題提起",
  problemStatementPlaceholder: "問題文またはクイズの文を入力してください",
  addOptionsAndMarkCorrectAnswer: "選択肢を追加して正解をマークします",
  markCorrectAnswer: "正解をマークしてください",
  addCorrectAnswer: "正解を追加",
  enterCorrectAnswerForBlank:
    "空白の {{number}} に正しい答えを入力してください",
  blankWithNumber: "空白の {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "回答を有効にするには、「&blank」を使用して適切な問題ステートメントを追加します。",
  enterSolution: "ソリューションを入力してください",
  enterExplanation: "説明を入力してください",
  codingSolutionExplanationPlaceholder:
    "最適なソリューションで処理されるロジック、アプローチ、エッジ ケースを簡単に説明する",
  optionWithNumber: "オプション {{number}}",
  enterExplanationForAnswer: "回答 {{number}} の説明を入力してください",
  addOptionToEnableExplanation:
    "説明を有効にするには、オプション {{number}} を追加します。",
  enterExplanationForBlank: "空白の {{number}} の説明を入力してください",
  addProblemStatementWithBlankToEnableExplanation:
    "説明を有効にするには、「&blank」を使用して適切な問題ステートメントを追加します。",
  enterHint: "ヒントを入力してください",
  addUpTo3Hints: "ヒントを 3 つまで追加します",
  addMoreOptions: "さらにオプションを追加する",
  answer: "答え",
  exitCodeBlockInfo:
    "コード ブロックを終了するには、行の最後に移動して「Enter」を 3 回クリックします。",
  fibBlankInsertionInfo:
    "空白を追加するには、テキストを選択して「空白の挿入」ボタンをクリックするか、手動で &blankN を追加します。ここで、N は任意の整数です (例: &blank1;)。",
  htmlEditorAccessInfo:
    "コードを追加したり形式を制御するには、編集アイコンをクリックして HTML エディタにアクセスします。",
  skillSelectionCannotBeEmpty: "スキルの選択を空にすることはできません",
  maxDurationInfo:
    "ユーザーがこの質問に対する回答を記録するために許可される最大時間。",
  minDurationInfo:
    "ユーザーが応答を送信する前に完了する必要がある最小限の録音時間。",
  uploadLimitInfo: "最終送信前にユーザーが応答を再記録できる回数。",
  textQuestionTitle: "これはテキストの質問です",
  audioRecordQuestionTitle: "これは音声録音に関する質問です",
  audioUploadQuestionTitle: "これは音声アップロードに関する質問です",
  videoRecordQuestionTitle: "これはビデオ録画に関する質問です",
  videoUploadQuestionTitle: "これは動画アップロードに関する質問です",
  subjectiveQuestionUploadConfigTitle:
    "主観的な質問 アップロード設定のタイトル",
  recordingLimitInMinutes: "録音制限(分)",
  minimumResponseDurationInMinutes: "最小応答時間(分)",
  recordingLimitLessThanTwenty: "録音制限は 20 未満にする必要があります",
  recordingLimitGreaterThanOrEqualOne: "記録制限は 1 以上である必要があります",
  minimumDurationLessThanRecordingLimit:
    "最小応答時間は録音制限未満である必要があります",
  durationGreaterThanPointFive: "期間は 0.5 より大きくなければなりません",
  uploadLimitGreaterThanZero:
    "アップロード制限は 0 より大きくなければなりません",
  addFieldSelectCodingLanguagesInfo:
    "{{fieldLabel}} を追加するには、まず「{{basicDetails}}」セクションで許可されるコーディング言語を選択してください。",
  basicDetails: "基本的な詳細",
  loadingEditor: "エディターを読み込み中...",
  run: "実行",
  writingSolutionInLanguage: "あなたは現在ソリューションを書いています",
  changingToLanguageWillClearInput: "に変更します",
  unsavedChangesWillBeLostInLanguage: "保存されていない変更内容",
  changeLanguage: "言語を変更する",
  testCase: "テストケース",
  add: "追加",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "以下に、少なくとも 2 つの表示テスト ケースと 3 つの非表示テスト ケースを追加します。",
  visibleToCandidatesForSelfEvaluation: "自己評価のために候補者に表示されます",
  noVisibleTestCasesAddedYet:
    "表示可能なテスト ケースはまだ追加されていません。追加するには、下のボタンをクリックしてください。",
  visibleTestCasesCannotExceedTwenty:
    "表示可能なテストケースは 20 個を超えることはできません",
  addMoreVisibleTestCases: "表示可能なテスト ケースをさらに追加する",
  maximumTestCasesLimitReached: "テストケースの最大制限に達しました",
  hiddenToCandidatesRunsAfterSubmit:
    "候補者には非表示、候補者が提出した後に実行されます",
  noHiddenTestCasesAddedYet:
    "非表示のテスト ケースはまだ追加されていません。追加するには、下のボタンをクリックしてください。",
  hiddenTestCasesCannotExceedTen:
    "非表示のテストケースは 10 個を超えることはできません",
  addMoreHiddenTestCases: "非表示のテスト ケースをさらに追加する",
  hiddenTestCase: "隠されたテストケース",
  visibleTestCase: "目に見えるテストケース",
  someQuestionsCouldNotBeUpdated:
    "一部の質問は更新できませんでした。質問を確認して、もう一度お試しください。",
  publishSummary: "概要の公開",
  sendForReviewSummary: "レビューのために送信する",
  moveToDraftSummary: "草案の概要に移動",
  actionSummary: "アクションの概要",
  publishSummarySubtitle:
    "公開アクションの概要は次のとおりです。以下の詳細を確認してください。",
  sendForReviewSummarySubtitle:
    "レビューリクエストの概要は次のとおりです。以下の詳細を確認してください。",
  moveToDraftSummarySubtitle:
    "ドラフトへの移行アクションの概要は次のとおりです。以下の詳細を確認してください。",
  actionSummarySubtitle:
    "あなたの行動の概要は次のとおりです。以下の詳細を確認してください。",
  successfully: "成功しました",
  failedTo: "失敗しました",
  moveToDraft: "ドラフトに移動",
  details: "詳細",
  questionTitle: "質問のタイトル",
  reason: "理由",
  showLess: "表示を少なくする",
  showMoreCount: "さらに {{count}} 件表示",
  uploadedAllCountItems: "すべての {{count}} {{item}} をアップロードしました",
  partiallyUploadedCountItems:
    "部分的にアップロードされました {{successCount}}/{{totalCount}} {{item}}",
  users: "ユーザー",
  questions: "質問",
  viewErrors: "エラーを表示する",
  errorsWithFileName: "エラー - {{fileName}}",
  inputIsRequired: "入力は必須です",
  expectedOutputIsRequired: "期待される出力が必要です",
  expectedOutputCannotBeBlank:
    "予期される出力は空またはスペースだけであってはなりません",
  marksMustBeNumber: "マークは数字である必要があります",
  marksAreRequired: "マークは必須です",
  hiddenTestCaseMarksGreaterThanZero:
    "続行するには、非表示のテスト ケースのマークが 0 より大きい必要があります。",
  hiddenTestCaseMarksMaxThirtyThousand:
    "非表示のテスト ケースのマークは 30,000 を超えてはなりません。",
  explanationMinFiveIfProvided:
    "説明を提供する場合は少なくとも 5 文字にする必要があります",
  explanationIsRequired: "説明が必要です",
  explanationMinFiveNotBlank:
    "説明はスペースだけではなく、少なくとも 5 文字にする必要があります",
  provideInput: "入力を提供する",
  provideExpectedOutput: "期待される出力を提供する",
  enterScore: "スコアを入力してください",
  optional: "オプション",
  explainTestCase: "テストケースを説明する",
  updateTestCase: "テストケースを更新する",
  addTestCase: "テストケースの追加",
  deleteQuestionWithTitlePrompt:
    "この質問「{{title}}」を削除してもよろしいですか?",
  errorFetchingData: "データ取得エラー",
  rowNumber: "行番号",
  columnName: "列名",
  useCase: "使用事例",
  startsAt: "開始時刻",
  endsAt: "で終了",
  invite: "招待する",
  viewReport: "レポートを見る",
  successfullyDeletedAssessment: "評価が正常に削除されました",
  successfullyFreezeActionAssessment: "{{action}} 評価に成功しました",
  freezeOperationFailed: "フリーズ操作が失敗しました",
  deleteAssessmentWithTitlePrompt:
    "「{{title}}」というタイトルのこの評価を削除してもよろしいですか?",
  freeze: "フリーズ",
  unfreeze: "解凍する",
  freezeAssessmentPrompt: "この評価を{{action}}してもよろしいですか?",
  expiresAt: "有効期限は次のとおりです",
  seePreview: "プレビューを見る",
  schedule: "スケジュール",
  skillBenchmarking: "スキルのベンチマーク",
  skillBenchmarkingOverview: "特定のスキルにおける参加者の習熟度の概要。",
  proctoringAnalysis: "監督分析",
  proctoringAnalysisOverview: "評価の監督関連の側面の簡単な概要。",
  proctoringStatus: "監督ステータス",
  noIrregularitiesReported: "異常は報告されていない。",
  monitoringOverview: "モニタリングの概要",
  complianceNoIncidents: "評価ルールの遵守。事件や報告された行動はありません。",
  viewEvidenceClicked: "証拠をクリックしました！",
  marksObtained: "獲得したマーク",
  correctAnswer: "正解",
  wrongAnswer: "不正解",
  sectionWiseAnalysis: "セクションごとの分析",
  sectionWiseAnalysisOverview: "各質問の概要と候補者の回答。",
  openAllSections: "すべてのセクションを開く",
  closeAllSections: "すべてのセクションを閉じる",
  sectionWithNumber: "セクション {{number}}:",
  score: "スコア",
  questionAnalysis: "質問分析",
  questionTitleFallback: "質問のタイトル",
  candidateAnswer: "回答候補",
  loadAllQuestions: "すべての {{count}} {{item}} をロード",
  attemptWithNumber: "試行 #{{number}}",
  invalidReportUrl: "無効なレポート URL",
  failedToDownloadReportTryAgainLater:
    "レポートのダウンロードに失敗しました。後でもう一度試してください。",
  downloadReport: "レポートのダウンロード",
  participantName: "参加者名",
  dateOfAttempt: "試行日",
  fail: "失敗",
  pass: "合格",
  userScoredInAssessment: "{{name}} は評価で {{percentage}} を獲得しました。",
  overallSummary: "全体的な概要",
  sectionAnalytics: "セクション分析",
  allAttempts: "すべての試行",
  bestAttempt: "ベストアテンプト",
  latestAttempt: "最新の試み",
  participantList: "参加者リスト",
  totalParticipantsInvited: "招待された参加者の合計",
  notStarted: "未開始",
  inProgress: "進行中",
  resultsInProgress: "進行中の結果",
  searchByNameOrEmail: "名前またはメールアドレスで検索",
  noUsersAvailableReportCannotBeGenerated:
    "利用可能なユーザーがいません - レポートを生成できません。",
  userName: "ユーザー名",
  totalAttempt: "合計試行回数",
  percentage: "割合(%)",
  attemptTimeline: "試行タイムライン",
  noDataFound: "データが見つかりませんでした",
  outOfMarks: "{{max}} マーク中 {{obtained}}",
  resultInProcess: "処理中の結果",
  participantNotFound: "参加者が見つかりません!",
  searchedParticipantNotFound: "検索した参加者が見つかりません!",
  noParticipantEnrolled: "参加者が登録されていません!",
  noDataToDisplay: "表示するデータがありません",
  participantsPerPage: "ページごとの参加者数:",
  actionFailed: "アクションが失敗しました",
  failedToRemoveUser: "ユーザーの削除に失敗しました",
  bestScoreAcrossAttemptsInfo: "複数回の試行で達成された最高スコアを示します。",
  successfullyRemovedUser: "ユーザーが正常に削除されました",
  successfullyReinvitedUser: "ユーザーを再招待しました",
  reinviteTooltip: "進行中の評価をまだ開始していない参加者を再度招待します。",
  reInvite: "再招待",
  noParticipantsInvitedYet: "まだ参加者が招待されていません",
  scheduleExpired: "スケジュールが期限切れになりました",
  assessmentIsOngoing: "評価は進行中です",
  assessmentCompleted: "評価完了",
  resultNotProcessed: "結果は処理されませんでした",
  assessmentNotStarted: "評価が開始されていません",
  remove: "取り除く",
  confirmReInvitation: "再招待の確認",
  confirmReinviteMessage:
    "進行中の評価をまだ開始していない参加者を再度招待してもよろしいですか?",
  removeUserWithNamePrompt: "「{{name}}」を削除してもよろしいですか?",
  groupType: "グループタイプ",
  objectiveGroupType: "客観的",
  codingGroupType: "コーディング",
  subjectiveTextSpeakingGroupType: "主観 (テキスト/スピーキング)",
  groupTypeImmutableInfo:
    "グループの種類は後で変更できません。そのタイプの質問のみを追加できます。",
  sameMarkGroupingTitle:
    "質問は同じマーク値を持つ場合にのみグループ化できます。",
  sameMarkGroupingDescription:
    "グループ内でマーク値 (2 マークと 5 マークなど) が混在すると、一部の質問のみが選択された場合にセクションのスコアが異なる可能性があります。スコアの一貫性を保つために、同様のマーク付き質問をグループ化します。",
  searchQuestion: "質問の検索",
  addAllSelectedQuestions: "選択した{{count}}の質問をすべて追加します",
  singleQuestionSelectedCount: "{{count}}件の質問を選択済み",
  allQuestionsSelectedCount: "{{count}}件の質問をすべて選択済み",
  selectedCountOfTotalQuestions:
    "全{{total}}件中{{selected}}件の{{label}}を選択",
  addSelectedQuestion: "選択した質問を追加します",
  validationErrors: "検証エラー",
  failedToAddToGroup: "グループへの追加に失敗しました",
  questionsAddedSuccessfullyWithCount: "{{count}} の質問が正常に追加されました",
  successfullyUpdatedAssessment: "評価が正常に更新されました",
  editCustomTnc: "カスタム利用規約の編集",
  addCustomTnc: "カスタム利用規約の追加",
  attributes: "属性",
  added: "追加済み",
  addAttributes: "属性の追加",
  clickHereToAddEditAttributes: "属性を追加・編集するにはここをクリック",
  clickHereToAddAttributes: "属性を追加するにはここをクリック",
  addTncAndSave: "利用規約を追加して保存",
  savedWithFollowingErrors: "以下のエラーが発生した状態で保存されました",
  selectDomain: "ドメインを選択",
  selectRegion: "地域を選択",
  selectUsage: "用途を選択",
  selectCategoryFirst: "先にカテゴリを選択してください",
  selectSubCategory: "サブカテゴリを選択",
  addAttributesAndSave: "属性を追加して保存",
  questionPaperTimer: "試験問題用タイマー",
  sectionLevelTimer: "セクション単位タイマー",
  questionLevelTimer: "問題単位タイマー",
  loginWindowDescription:
    "受験者は、開始時刻以降の限られた時間内のみ参加できます。",
  durationBasedDescription:
    "終了時刻は、開始時刻＋試験時間から自動計算されます。",
  deadlineDescription:
    "開始時刻と終了時刻は固定です。受験者は期限までに終了する必要があります。",
  loginWindowInfo:
    "ログインウィンドウとは、予定された開始時刻の後に受験者がアセスメントを開始できる時間（分単位）のことです。ログインウィンドウが閉じると、新しい受験者は入場できなくなります。ログインウィンドウは、試験の制限時間以下である必要があります。",
  assessmentDurationInfo:
    "開始時刻のみを設定してください。システムが試験時間を加算して、終了時刻を自動的に計算します。",
  startTimeMinAheadInfo:
    "開始時刻は、現在時刻より少なくとも15分以上先である必要があります。",
  loginWindowExample:
    "例：開始時刻が午前9:00で、ログインウィンドウが30分の場合、受験者は9:00〜9:30の間に開始でき、5分間の追加バッファがあります。",
  assessmentDurationExample:
    "例：開始時刻が午前9:00で、試験時間が60分の場合、アセスメントは午前10:00に終了し、5分間の追加バッファがあります。",
  freeFlow: "自由移動（フリーフロー）",
  oneByOne: "一問ずつ表示",
  subjectiveNoResultInfo: "記述式『結果なし』に関する情報",
  candidateResultVisibility: "受験者への結果公開設定",
  noResult: "結果なし",
  passPercentageRangeError: "合格基準パーセンテージの範囲エラー",
  attemptsAllowedInfo: "許可された受験回数の情報",
  maxAttemptsError: "エラー：最大受験回数を超えています",
  maximumAttemptsInfo: "最大受験回数の情報",
  limitedAttempts: "回数制限あり",
  coolOffDescription: "再受験待機期間（クールオフ）の説明",
  noCoolOffPeriod: "再受験待機期間なし",
  waitFor: "待機時間：",
  hours: "時間",
  days: "日間",
  whatLearnersWillSee: "受講者に表示される画面",
  unlimitedAttemptsInfo: "このアセスメントでは、回数無制限で受験いただけます。",
  waitBeforeNextAttemptPrefix: "各受験後、次の受験を開始するまで",
  waitBeforeNextAttemptSuffix: "待機する必要があります。",
  waitBeforeNextAttempt:
    "各受験後、次の受験を開始するまで {duration} 待機する必要があります。",
  singleAttemptInfo: "このアセスメントでは 1 回受験できます。",
  remainingAttemptsInfoPrefix: "このアセスメントでは",
  remainingAttemptsInfoMiddle: "中",
  remainingAttemptsInfoSuffix: "回受験できます。",
  remainingAttemptsInfo:
    "このアセスメントでは {total} 回中 {remaining} 回受験できます。",
  enableCertificate: "修了証・認定証を有効にする",
  enableCertificateDescription:
    "評価を正常に完了した候補者に修了証・認定証を発行します。",
  maxAllowed100: "最大100まで許可",
  scheduleAssessment: "評価のスケジュール設定",
  privateAssessmentLabel: "非公開評価",
  publicAssessmentLabel: "公開評価",
  privateAssessmentDescription:
    "この評価は招待ベースのみで、定義された開始時刻と終了時刻の範囲内でのみ利用できます。",
  publicAssessmentDescription:
    "この評価は自己割り当てと招待ベースの両方のアクセスに対応し、固定のアクセス時間枠はありません。",
  schedulePublicAssessment: "公開評価のスケジュール設定",
  successfullyPublishedAssessment: "評価が正常に公開されました",
  publishWithoutProctoringPrompt:
    "オンライン監視（プロクタリング）なしで公開しますか？",
  publishAssessmentPrompt: "評価を公開しますか？",
  sectionScoreAnalysis: "セクション別スコア分析",
  sectionScoreAnalysisOverview: "セクション別スコア分析の概要",
  section: "セクション",
  noSectionDataAvailable: "該当セクションのデータはありません",
  difficultyLevelAnalysis: "難易度別の分析",
  browserViolations: "ブラウザ違反行為",
  videoViolations: "ビデオ違反行為",
  times: "回",
  statusMessageUnavailable: "ステータスメッセージを取得できません",
  viewViolationEvidence: "違反の証拠を確認する",
  noBrowserViolationsDetected: "ブラウザ違反は検出されませんでした",
  noVideoViolationsDetected: "ビデオ違反は検出されませんでした",
  candidateNotAttemptedCodingMessage:
    "メッセージ：受験者はコーディング問題に解答していません",
  candidateCode: "受験者のコード",
  candidateScore: "受験者のスコア",
  compilationCount: "コンパイル回数",
  submissionCount: "提出回数",
  timeTaken: "所要時間",
  testCaseReport: "テストケースのレポート",
  performanceAndCompilationMetrics: "パフォーマンスおよびコンパイル指標",
  totalTestCases: "総テストケース数",
  testCasesPassed: "合格したテストケース数",
  testCaseDetails: "テストケースの詳細",
  searchQuestions: "質問を検索",
  clearSearch: "検索をクリア",
  question: "質問",
  isSelected: "が選択されています",
  areSelected: "が選択されています",
  selected: "選択済み",
  questionsPerPage: "ページあたりの質問数:",
  publishQuestions: "質問を公開",
  send: "送信",
  move: "移動",
  publishQuestionsConfirmation:
    "本当に {{count}} 件の {{label}} を公開しますか？",
  sendForReviewConfirmation:
    "本当に {{count}} 件の {{label}} をレビューに送信しますか？",
  moveToDraftConfirmation:
    "本当に {{count}} 件の {{label}} を下書きに移動しますか？",
  bulkPublishDisclaimer:
    "公開する前に、選択したすべての質問が完全で正確であり、意図した通りに表示されていることを確認してください。",
  bulkReviewDisclaimer:
    "レビューに送信する前に、選択したすべての質問が完全で正確であり、意図した通りに表示されていることを確認してください。",
  bulkDraftDisclaimer:
    "下書きに移動する前に、選択したすべての質問が完全で正確であり、意図した通りに表示されていることを確認してください。",
  questionsUnderProcess:
    "質問は処理中です。質問 ステータスを確認するには、詳細を表示をクリックしてください。",
  mixedStatusesSelected: "複数のステータスが選択されています",
  mixedStatusesWarning:
    "続行する前に、選択したすべての質問のステータスが同じであることを確認してください。",
  selectionLimitReached: "選択上限に達しました",
  selectionLimitWarning:
    "一括操作で選択できる質問は {{count}} 件までです。別の質問を選択する前に、現在の選択を解除してください。",
  knowMore: "詳細を見る",
  guideLearnersRightDepth: "適切な深さに合った質問で学習者を導きましょう。",
  bloomCreateDescription:
    "複数の概念を用いて、新しいシステムやコードのソリューションを設計、構築、または作成する学習者の能力を評価します。",
  bloomEvaluateDescription:
    "学習者がコードを批判的に評価し、選択を正当化し、または異なるソリューションを評価できるかどうかを確認します。",
  bloomAnalyzeDescription:
    "コードを分解し、デバッグし、ロジックをトレースし、または技術システムにおけるパターンを特定する学習者の能力をテストします。",
  bloomApplyDescription:
    "学習者が概念を適用して、実践的なコーディング問題や現実世界のシナリオを解決できるかどうかを評価します。",
  bloomUnderstandDescription:
    "学習者が自分の言葉で概念を理解・説明できるか、または挙動を解釈できるかを確認します。",
  bloomRememberDescription:
    "基本的な定義、構文、および事実情報を思い出す学習者の能力を評価します。",
  bloomVerbCreate: "作成する",
  bloomVerbDesign: "設計する",
  bloomVerbConstruct: "構築する",
  bloomVerbDevelop: "開発する",
  bloomVerbEvaluate: "評価する",
  bloomVerbJustify: "正当化する",
  bloomVerbDefend: "弁護する",
  bloomVerbAssess: "査定する",
  bloomVerbAnalyze: "分析する",
  bloomVerbDifferentiate: "区別する",
  bloomVerbOrganize: "整理する",
  bloomVerbCompare: "比較する",
  bloomVerbApply: "適用する",
  bloomVerbUse: "使用する",
  bloomVerbDemonstrate: "実証する",
  bloomVerbSolve: "解決する",
  bloomVerbExplain: "説明する",
  bloomVerbDescribe: "記述する",
  bloomVerbSummarize: "要約する",
  bloomVerbInterpret: "解釈する",
  bloomVerbList: "列挙する",
  bloomVerbDefine: "定義する",
  bloomVerbName: "命名する",
  bloomVerbRecall: "想起する",
  bloomVerbRecognize: "認識する",
  bloomCreateExample1:
    "ReactとReduxを使用してシングルページアプリケーションを作成する。",
  bloomCreateExample2: "配車アプリのデータベースのスキーマを設計する。",
  bloomCreateExample3: "GitHub Actionsを使用してCI/CDパイプラインを開発する。",
  bloomEvaluateExample1:
    "マイクロサービスアーキテクチャにおいて、SQLではなくNoSQLを使用するメリットとデメリットを評価する。",
  bloomEvaluateExample2:
    "Reactコンポーネントのパフォーマンスを最適化するための改善策を提案する。",
  bloomAnalyzeExample1:
    "マージソートとクイックソートのパフォーマンスを比較する。",
  bloomAnalyzeExample2: "この再帰関数のメモリ使用量を分析する。",
  bloomAnalyzeExample3: "このJavaScriptコードブロック内のエラーを分類する。",
  bloomApplyExample1:
    "二分探索アルゴリズムを適用して、配列内の要素を検索する。",
  bloomApplyExample2: "Pythonでループを使用してフィボナッチ数列を出力する。",
  bloomApplyExample3: "ハッシュマップを使用して現実世界の問題を解決する。",
  bloomUnderstandExample1: "LIFOの原則を用いてスタックの仕組みを説明する。",
  bloomUnderstandExample2:
    "JavaScriptにおけるvar、let、constの違いを記述する。",
  bloomUnderstandExample3: "与えられたSQLクエリの出力を解釈する。",
  bloomRememberExample1:
    "ハイパーリンクを作成するための正しいHTMLタグを特定する。",
  bloomRememberExample2:
    "オブジェクト指向プログラミング（OOP）の4つの柱を挙げる。",
  bloomRememberExample3: "Javaのプリミティブデータ型を列挙する。",
  commonVerbs: "よく使う動詞",
  exampleQuestions: "質問例",
  noExamplesAvailable: "利用可能な例はありません。",
  candidateResponse: "受験者の回答",
  correctQuestions: "正解した問題",
  totalQuestions: "総問題数",
  correctQuestionPercentage: "正解率",
  performance: "パフォーマンス",
  level: "レベル",
  noOfQuestions: "質問数",
  correctAttempts: "正解数",
  correctness: "正確さ",
  partiallyCorrect: "部分的に正解",
  partiallyCorrectPercentage: "部分正解率",
  rescheduleAssessmentPrompt:
    "タイトル「{{title}}」のアセスメントの日程を再調整するかどうか確認してください。",
  assessmentAlreadyStarted: "アセスメントは既に開始されています",
  readMore: "続きを読む",
  best: "人気",
  latest: "最新",
  allQuestions: "すべての質問",
  myQuestions: "私の質問",
  publicQuestions: "公開質問",
  remarks: "備考",
  addRemarks: "備考を追加",
  noGroupsAdded: "グループはまだ追加されていません",
  addGroupInfo:
    "質問の追加を始めるには、まずグループを作成してください。開始するには、下の「セクションにグループを追加」ボタンをクリックします。",
  exitPreview: "プレビューを終了",
  preview: "プレビュー",
  problemStatementNotAdded: "問題文が追加されていません",
  durationDayUnit: "日",
  durationDaysUnit: "日",
  durationHourUnit: "時間",
  durationHoursUnit: "時間",
  durationMinuteUnit: "分",
  customFieldAddedForSingleLanguage:
    "カスタム{{fieldLabel}}は{{total}}言語中{{current}}言語で追加されています",
  customFieldAddedForMultipleLanguages:
    "カスタム{{fieldLabel}}は{{total}}言語中{{current}}言語で追加されています",
  email: "メール",
  tagInputHint: "カンマで区切って追加",
  enterOptions: "オプションを入力",
  groupNotFound: "グループが見つかりません",
  sheetNotFound: "シートが見つかりません",
  missingHeaders: "必須ヘッダーが不足しています",
  assetNotFound: "アセットが見つかりません",
  noValidDataFound: "有効なデータが見つかりません",
  notFoundPID: "参加者が見つかりません。",
  invalidParticipants: "無効な参加者です。",
  alreadyAdded: "参加者はすでに追加されています。",
  duplicateData: "重複データが見つかりました。",
  invalidData: "無効なデータです。",
  warnings: "警告",
  assignedToMyself: "自分に割り当てられています (自己学習)",
  assignedByMe: "自分が割り当てたもの (マイタスク)",
  urlCopiedToClipboard: "URLがクリップボードにコピーされました!",
  failedToCopyUrl: "URLのコピーに失敗しました。",
  content: "コンテンツ",
  platformHelp: "プラットフォームヘルプ",
  privacyPolicy: "プライバシーポリシー",
  logout: "ログアウト",
  logoutConfirmTitle: "ログアウトしてもよろしいですか？",
  logoutConfirmDescription:
    "離れますか？いつでも戻って、前回の続きから再開できます。",
  stayEngaged: "続ける"
} as const;
export default ja;
